<h2 mat-dialog-title class="report-dialog-title"><mat-icon>bolt</mat-icon>Voltage query</h2>
<div mat-dialog-content>
  <p class="report-dialog-description">Set the voltage range to include in the health report.</p>
  <div class="report-dialog-toggle">
    <mat-slide-toggle [(ngModel)]="hasGeo" name="hasGeo">Has geolocation</mat-slide-toggle>
  </div>
  <div class="report-dialog-form">
    <mat-form-field appearance="outline"><mat-label>Minimum voltage</mat-label>
      <input matInput type="number" [(ngModel)]="min" name="min" step="0.01" [min]="2" [max]="5"><span matTextSuffix>V</span>
    </mat-form-field>
    <mat-form-field appearance="outline"><mat-label>Maximum voltage</mat-label>
      <input matInput type="number" [(ngModel)]="max" name="max" step="0.01" [min]="1" [max]="10"><span matTextSuffix>V</span>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions class="report-dialog-actions">
  <button mat-stroked-button (click)="onNoClick()">Cancel</button>
  <button mat-flat-button class="report-dialog-primary" [mat-dialog-close]="true" (click)="yesClicked()" cdkFocusInitial>Run query</button>
</div>
